import React, { Component } from "react";
import { API } from "aws-amplify";
import {
  Image,
  FormGroup,
  FormControl,
  ControlLabel,
  Form,
  Checkbox,
  Col
} from "react-bootstrap";
import { Link } from "react-router-dom";
import LoaderButton from "../components/LoaderButton";
import "./Signup.css";
import TermsAndConditions from "../components/TermsAndConditions";

export default class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      picture: "",
      userName: "",
      providerId: "",
      confirmTerms: ""
    };
  }
  async componentDidMount() {
    const storedUser = JSON.parse(localStorage.getItem("LoginUser"));
    console.log("Signup stored user", storedUser);
    if (storedUser == null) {
      this.props.history.push("/login");
    } else {
      this.setState({
        isLoading: false,
        email: storedUser.email,
        userName: storedUser.userName,
        picture: storedUser.picture,
        providerId: storedUser.providerId
      });
      console.log("State", this.state);
    }
  }
  validateForm() {
    return (
      this.state.email.length > 0 &&
      this.state.userName.length > 0 &&
      this.state.confirmTerms
    );
  }

  handleChange = event => {
    console.log("handle change", event.target);
    console.log(event.target.id, event.target.value);
    this.setState({
      [event.target.id]: event.target.value
    });
  };
  handleCheckbox = event => {
    console.log("handleCheckbox", event.target);
    console.log(event.target.id, event.target.checked);
    this.setState({
      [event.target.id]: event.target.checked
    });
  };

  handleSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });
    console.log("handleSubmit starting");
    try {
      const bodySignUp = {
        body: {
          Email: this.state.email,
          Picture: this.state.picture,
          ProviderID: this.state.providerId,
          TermsAccepted: this.state.confirmTerms,
          UserName: this.state.userName
        }
      };
      console.log("bodySignUp :", bodySignUp);
      console.log("Sign user.");

      var responseLogin = await API.post("books", "user/signup", bodySignUp);
      if (responseLogin.status) {
        this.props.history.push("/login?1");
      }
    } catch (e) {
      console.log("handleSubmit error", e);
      if (e.name === "UsernameExistsException") {
        alert(e.message);
      } else alert(e.message);
    }

    this.setState({ isLoading: false });
  };

  renderForm() {
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <FormGroup controlId="userPicture" bsClass="centered">
            <Col sm={12}>
              <Image
                src={this.state.picture}
                circle
                responsive
                alt="Profile Picture"
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="userName" bsSize="lg" inline="true">
            <Col componentClass={ControlLabel} sm={2}>
              Name
            </Col>
            <Col sm={10}>
              <FormControl
                value={this.state.userName}
                onChange={this.handleChange}
                type="userName"
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="email" bsSize="lg" inline="true">
            <Col componentClass={ControlLabel} sm={2}>
              Email
            </Col>
            <Col sm={10}>
              <FormControl
                autoFocus
                type="email"
                value={this.state.email}
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>

          <FormGroup controlId="confirmTerms" bsSize="lg">
            <Col smOffset={2} sm={10}>
              <TermsAndConditions />
              <Checkbox
                id="confirmTerms"
                checked={this.state.confirmTerms}
                onChange={this.handleCheckbox}
              >
                <ControlLabel>
                  Accept{" "}
                  <Link target="bukHuTerms" to="/terms">
                    Terms and Conditions
                  </Link>
                </ControlLabel>
              </Checkbox>
            </Col>
          </FormGroup>
          <LoaderButton
            block
            bsSize="large"
            disabled={!this.validateForm()}
            type="submit"
            isLoading={this.state.isLoading}
            text="Signup"
            loadingText="Signing up…"
          />
        </Form>
      </div>
    );
  }

  render() {
    return <div className="Signup">{this.renderForm()}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/containers/Signup.js